<template>
	<div :class="['multichoice2', { 'editable': settings.editable }]">
		<div v-if="settings.editable" class="">
			<nk-dropdown :options="settings.dropdown" v-model="dropdownSelectedItem" @update:modelValue="selectedItemsChanged" :data="dropdownData" :tabindex="tabindex" :startup="startup ? true : null" ref="dropdown" :disable="!settings.editable">
				<template #items>
					<div v-if="mergeItems" class="merge-items item">
						{{ dropdownSelectedItem.length.toString() + $t('item-selected') }}
						<i class="fa fa-times remove mx-1" v-if="settings.editable" @click="removeAllItems()"></i>
					</div>
					<div v-else v-for="(x, i) of dropdownSelectedItem" :key="i" class="item">
						<div v-html="settings.display(x).toLocaleDigits()" class="val"></div>
						<i class="fa fa-times remove" v-if="settings.editable" @click="remove(i)"></i>
					</div>
				</template>
			</nk-dropdown>
		</div>
	</div>
</template>

<script>
	import _ from 'lodash'
	import $ from 'jquery'
	import TabOrder from '~/statics/taborder-functions'
	import cloneDeep from 'lodash/cloneDeep'

	export default {
		props: {
			options: {},
			modelValue: { type: Array, default: () => [] },
			data: { type: Array },
			tabindex: { type: [String, Number] },
			startup: { type: Boolean }
		},
		emits: ['update:modelValue', 'resized'],
		data() {
			return {
				settings: {
					getDataFromOptions: false,
					editable: true,
					dropdown: {
						searchRequestFilter: this.onDropdownSearchRequestFilter,
						placeholder: this.$t('search'),
						multiSelection: true,
						rowIdentifier: 'id' || 'key' || 'value',
						display: (item) => {
							if (item.name) { return item.name } else if (item.text) { return item.text } else if (item.value) { return item.value } else if (item.title) { return item.title }
							return item
						}
					},
					comparer: (first, second) => first === second,
					display: (item) => item,
					showEmptyLabel: false,
					maxSelectedCount: 0
				},
				selecteds: [],
				dropdownSelectedItem: [],
				activeIndex: -1,
				mergeItems: false
			}
		},
		computed: {
			dropdownData() {
				if (this.settings.getDataFromOptions)
					return this.settings.data

				return this.data
			},
		},
		watch: {
			options: {
				immediate: true,
				deep: true,
				handler(val) {
					this.settings = _.merge({}, this.settings, val)
				}
			},
			modelValue: {
				immediate: true,
				deep: true,
				handler(val) {
					this.dropdownSelectedItem = cloneDeep(val)
					this.$nextTick(() => this.setMergeItems())
				}
			},
			'settings.editable': {
				handler(val, oldVal) {
					if (val !== oldVal) {
						this.defer(() => {
							let grandParentType = this.grandParentType()
							TabOrder.subscribeKeys(grandParentType, this)
						}, 500)
					}
				}
			},
		},
		mounted() {

			// assigning id to datas if not given
			// id is required for selected's v-for to work properly
			// otherwise it selects all of the items by selecting one
			for (let index = 0; index < this.dropdownData.length; index++)
				if (!this.dropdownData[index].id)
					this.dropdownData[index].id = this.idGenerator(5)

			this.dropdownSelectedItem = this.modelValue

			this.$nextTick(() => _.debounce(() => {
				this.setMergeItems()
				this.emitAutoSize()
				this.emitSize()
			}, 150)())

		},
		methods: {
			removeAllItems() {
				if (this.settings.editable !== true) {
					return
				}
				this.dropdownSelectedItem = []
				this.mergeItems = false
				this.$emit('update:modelValue', this.dropdownSelectedItem)
				this.$refs.dropdown.$refs.input.pVal = ''

			},
			emitSize() {
				if (this.$refs.dropdown == null) {
					return
				}

				let $el = $(this.$el)

				let size = {
					width: parseFloat($el.width()),
					height: parseFloat($el.height())
				}

				size.width += parseFloat($el.css('border-left-width')) + parseFloat($el.css('border-right-width'))
				size.height += parseFloat($el.css('border-top-width')) + parseFloat($el.css('border-bottom-width'))

				this.$emit('resized', size)

				this.defer(() => {
					this.$el.dispatchEvent(new Event('resize'))
				}, 50)
			},
			emitAutoSize() {
				if (this.$refs.dropdown == null) {
					return
				}

				let w = $(this.$refs.dropdown.$el).width()
				$(this.$el).css('max-width', w)

				this.emitSize()

				$(this.$el).css('max-width', 'unset')
			},
			remove(index) {
				if (this.settings.editable !== true) {
					return
				}
				this.dropdownSelectedItem.splice(index, 1)
				this.$emit('update:modelValue', this.dropdownSelectedItem)
			},
			refocusActiveSelected() {
				this.defer(() => $(this.$el).find('.mc-items .mc-item.focused').focus(), 1)
			},
			refocusDropdown() {
				this.defer(() => {
					let drp = this.$refs.dropdown
					if (drp != null) {
						$(drp.$el).find('input').focus()
					}
				}, 1)
			},
			clearEditor() {
				//this.dropdownSelectedItem = null
			},

			dropdownSelectedItemChanged(val) {
				if (!val) {
					val = []
				}

				if (this.settings.maxSelectedCount > 0 && val.length >= val.maxSelectedCount) {
					val.shift()
				}

				this.$emit('update:modelValue', val)
			},
			onDropdownSearchRequestFilter(item, request) {
				if (item != null) {
					if (typeof this.settings.searchRequestFilter === 'function') {
						var res = this.settings.searchRequestFilter(this.selecteds, request)
						request = $.extend(true, {}, request, res)
					}
				}

				return request
			},
			onItemClicked(e, index) {
				this.activeIndex = index
				e.preventDefault()
				e.stopPropagation()
			},

			subscribeKeys() {
				this.$keyHandler.Subscribe({
					name: 'multichoice-nav-left',
					keyCode: [37], // 37:arrow-left
					el: this.$el,
					context: this,
					handler: function (sender, e) {
						if (!this.selecteds || this.selecteds.length === 0) {
							this.activeIndex = -1
							return
						}

						e.preventDefault()

						if (this.activeIndex === -1) {
							this.activeIndex = 0
							this.refocusActiveSelected()
							return true
						} else if (this.activeIndex < this.selecteds.length - 1) {
							this.activeIndex += 1
							this.refocusActiveSelected()
							return true
						} else {
							this.activeIndex = -1
						}
					}
				})
				this.$keyHandler.Subscribe({
					name: 'multichoice-nav-right',
					keyCode: [39], // 39:arrow-right
					el: this.$el,
					context: this,
					handler: function (sender, e) {
						if (!this.selecteds || this.selecteds.length === 0) {
							this.activeIndex = -1
							return
						}

						e.preventDefault()

						if (this.activeIndex === 0) {
							this.activeIndex = -1
							this.refocusDropdown()
							return true
						} else if (this.activeIndex > 0 && this.activeIndex < this.selecteds.length) {
							this.activeIndex -= 1
							this.refocusActiveSelected()
							return true
						} else {
							this.activeIndex = -1
						}
					}
				})
				this.$keyHandler.Subscribe({
					name: 'multichoice-delete',
					keyCode: [8, 46], // 8:backspace 46:delete
					el: this.$el,
					context: this,
					handler: function (sender, e) {
						if (this.activeIndex > -1 && this.activeIndex < this.selecteds.length) {
							let item = this.selecteds[this.activeIndex]
							this.removeItem(item)
						}
					}
				})
			},
			getSelectedItemsText() {
				if (this.dropdownSelectedItem) {
					if (this.mergeItems)
						return this.dropdownSelectedItem.length.toString().toLocaleDigits() + this.$t('item-selected')

					var text = this.dropdownSelectedItem.length > 0 ? this.dropdownSelectedItem.map(x => this.settings.display(x)).join(' , ') : ''

					return text
				}
			},
			selectedItemsChanged(val) {
				this.setMergeItems()
				this.dropdownSelectedItemChanged(val)
			},
			setMergeItems() {
				const input = this.$el?.querySelector('.m-dropdown-input > input')
				if (!input) return (this.mergeItems = false)
					
				const inputWidth = input.offsetWidth
				const containerWidth = this.$el.offsetWidth

				this.mergeItems = inputWidth && containerWidth ? inputWidth <= containerWidth * 0.2 : false
			}
		}
	}
</script>

<style src="~/styles/multichoice.less" lang="less"></style>
